import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StayWithUs() {
  return <section data-section-id="222065" id="call-to-action" className="bg-background text-foreground">
      <div className="w-full bg-primary py-24 px-6 md:px-12 lg:px-24 flex flex-col items-center justify-center text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold mb-10 text-primary-foreground tracking-tighter">
            Secure Your Florida Keys Property Today
          </h2>
          <div className="flex flex-col sm:flex-row gap-5 items-center justify-center">
            <Button asChild className="w-full sm:w-auto bg-secondary text-secondary-foreground hover:bg-secondary/90 text-base font-default h-14 px-10 rounded-lg shadow-lg transition-colors">
              <Link to="https://trusted-fl.com/#schedule-your-inspection">Schedule Inspection</Link>
            </Button>
            <Button asChild variant="outline" className="w-full sm:w-auto border-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary bg-transparent text-base font-default h-14 px-10 rounded-lg transition-colors shadow-none">
              <Link to="https://trusted-fl.com/#service-areas">View Service Areas</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}